import React from "react";
import AppointmentTitle from "@/components/management/components/appointment/AppointmentTitle";
import AppointmentTable from "@/components/management/components/appointment/AppointmentTable";
import BranchRequiredWrapper from "@/components/banners/BranchRequiredWrapper";

const Appointments: React.FC = () => {
  return (
    <div className="container mx-auto md:px-4 py-2">
      <BranchRequiredWrapper>
        <AppointmentTitle />
        <AppointmentTable />
      </BranchRequiredWrapper>
    </div>
  );
};

export default Appointments;
